import React from "react";
import { Modal, Button } from "react-bootstrap";
import BarcodeScanner from "../../../../shared-components/scanner/barcode-scanner";
import { formatMessage } from "../../../../translations/format-message";

interface BarcodeScannerModalProps {
  show: boolean;
  onClose: () => void;
  onScan: (barcode: string) => void;
}

const BarcodeScannerModal: React.FC<BarcodeScannerModalProps> = ({
  show,
  onClose,
  onScan,
}) => {
  return (
    <Modal show={show} centered size="sm">
      <Modal.Header>
        <Modal.Title>
          {formatMessage("scan_barcode")}
          <button
            onClick={onClose}
            className="Crossicons"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="23"
              height="23"
              fill="currentColor"
              className="bi bi-x"
              viewBox="0 0 16 16"
            >
              <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" />
            </svg>
          </button>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <BarcodeScanner onBarcodeScanned={onScan} />
      </Modal.Body>
      <Modal.Footer>
        <Button variant="outline-danger" onClick={onClose}>
          <i className="bi bi-x-lg me-1"></i>
          {formatMessage("close")}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default BarcodeScannerModal;
